import { gaTracking, getCurrentPageLocation, normalizeString } from "../../lib/ga";

/**
 * Tracks personalization selector interactions
 * @param sector - Selected employment industry/sector
 * @param role - Selected employment role
 * @param context - Where the selector is shown
 * @param linktext - Action taken (confirm, cancel, or learn more)
 * @see /GAExamples/personalization_click.js
 */
export const sectorTracker = (
  sector: string,
  role: string,
  context: "målgruppsväljare_brödtext" | "målgruppsväljare_pop_up",
  linktext: "bekräfta" | "avbryt" | "förklara mer",
): void => {
  const normalizedRole = normalizeString(role) ?? "";
  const normalizedSector = normalizeString(sector) ?? "";

  gaTracking({
    event: "personalization_click",
    user_properties: {
      employment_role: normalizedRole,
      employment_industry: normalizedSector,
    },
    event_parameters: {
      page_location: getCurrentPageLocation().split("?")[0],
      feature_block_name: normalizeString(context) ?? "",
      employment_role: normalizedRole,
      employment_industry: normalizedSector,
      link_text: linktext,
    },
  });
};

/**
 * Tracks personalization selector impressions
 * @param context - Where the selector is shown
 * @see /GAExamples/personalization_impression.js
 */
export const sectorViewTracker = (
  context: "målgruppsväljare_brödtext" | "målgruppsväljare_pop_up",
): void => {
  gaTracking({
    event: "personalization_impression",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      feature_block_name: normalizeString(context) ?? "",
    },
  });
};
